<template>
	<div class="sf-datatable-wrapper">
		<sf-data-table
			ref="dataTable"
			:scrId="scrId"
			:paging="false"
			:columns="columns"
			:rows="rows"
			:stripe="false"
			selection
			style="height: 230px"
		>
		</sf-data-table>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.opCodeList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001096'), //op코드
					prop: 'opCd',
					minWidth: '120px',
					sortable: false,
					highlight: true,
					clickEvent: this.clickOpCd
				},
				{
					label: this.getMessage_('QWCC001807'), //op코드명
					prop: 'opNm',
					minWidth: '120px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001101'), //자재비
					prop: 'mtrlCst',
					minWidth: '120px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001102'), //공임비
					prop: 'wags',
					minWidth: '120px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001103'), //부대비
					prop: 'incdCst',
					minWidth: '120px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001104'), //총금액
					prop: 'sumAmt',
					minWidth: '120px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000001'), //교환부품수량
					prop: 'partCnt',
					minWidth: '120px',
					sortable: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async clickOpCd(row) {
			const opCd = row.opCd;
			this.$sf_toggleLoading(true);
			await this.getSearchCmpnPartList_(row).finally(() => this.$sf_toggleLoading(false));
		},
		getSelectedRows() {
			const selectedRow = this.$refs.dataTable.getSelectedRows();
			return selectedRow;
		}
	}
};
</script>
